import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";
export var RowWithBullet = function RowWithBullet(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Row, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Bullet, null), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), children));
};
var Bullet = styled.div.withConfig({
  displayName: "RowWithBullet__Bullet"
})(["width:4px;height:4px;border-radius:50%;background-color:", ";margin:6px 0;padding:3px;"], Core.surface["default"]);